export default "__VITE_ASSET__191cafdd__"